module.exports = __webpack_public_path__ + "img/makerdao.49332dd8.svg";